import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-input-renderer',
  templateUrl: './input-renderer.component.html',
  styleUrls: ['./input-renderer.component.scss']
})
export class InputRendererComponent implements OnInit,ICellRendererAngularComp {
  params;
  inputValue : string;
  constructor() { }

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    this.params = params;
    return true;
  }

  ngOnInit(): void {
  }
  inputValueEmit(value){
    this.params.value = value;
    const columnId = this.params.column.getId();
    this.params.data[columnId] = value;
    this.params.api.refreshCells({ rowNodes: [this.params.node], force: true });
    if(columnId == 'qty'){
      const customEvent = new CustomEvent('inputChangeClick', {
        detail : { data: this.params },
      });
      document.dispatchEvent(customEvent);
    }
  }
}
